@let resourceRow = row();

<div
  class="new-reservation-dialog__resource-row"
  [attr.data-cy]="'assist-new-reservation-location-row-' + resourceRow.resource.idForFiltering"
>
  <div class="new-reservation-dialog__resource-main">
    <ng-template #availabilityReasonsTemplate>
      <div class="new-reservation-dialog__tooltip-content">
        @for (reason of resourceRow.availabilityReasons; track reason) {
          <p>{{ reason }}</p>
        }
      </div>
    </ng-template>

    <div class="new-reservation-dialog__resource-main__container">
      <div class="new-reservation-dialog__resource-main__name">
        <span
          class="new-reservation-dialog__availability-dot"
          [class.new-reservation-dialog__availability-dot--loading]="resourceRow.availabilityState === 'loading'"
          [class.new-reservation-dialog__availability-dot--available]="resourceRow.availabilityState === 'available'"
          [class.new-reservation-dialog__availability-dot--warning]="resourceRow.availabilityState === 'warning'"
          [class.new-reservation-dialog__availability-dot--error]="resourceRow.availabilityState === 'error'"
          [class.new-reservation-dialog__availability-dot--unknown]="resourceRow.availabilityState === 'unknown'"
          [attr.aria-label]="resourceRow.availabilityLabelKey | transloco"
          [cueTooltip]="resourceRow.availabilityReasons.length > 0 ? availabilityReasonsTemplate : undefined"
          [cueTooltipCommonType]="'info'"
        ></span>
        <strong>{{ resourceRow.displayName }}</strong>
      </div>

      <div class="new-reservation-dialog__resource-text">
        <span>{{ resourceRow.resource.email }}</span>
      </div>
    </div>
  </div>

  <div class="new-reservation-dialog__resource-meta">
    <span
      class="new-reservation-dialog__availability-label"
      [class.new-reservation-dialog__availability-label--loading]="resourceRow.availabilityState === 'loading'"
      [class.new-reservation-dialog__availability-label--available]="resourceRow.availabilityState === 'available'"
      [class.new-reservation-dialog__availability-label--warning]="resourceRow.availabilityState === 'warning'"
      [class.new-reservation-dialog__availability-label--error]="resourceRow.availabilityState === 'error'"
      [class.new-reservation-dialog__availability-label--unknown]="resourceRow.availabilityState === 'unknown'"
    >
      {{ resourceRow.availabilityLabelKey | transloco }}
    </span>

    @if (resourceRow.schedulingRules.length > 0) {
      <ng-template #resourceSchedulingRulesTemplate>
        <dl class="new-reservation-dialog__rules-tooltip">
          @for (rule of resourceRow.schedulingRules; track rule) {
            @let separatorIndex = rule.indexOf(':');
            @if (separatorIndex > -1) {
              <dt>{{ rule.slice(0, separatorIndex) }}</dt>
              <dd>{{ rule.slice(separatorIndex + 1).trim() }}</dd>
            } @else {
              <dt class="new-reservation-dialog__rules-tooltip__full">{{ rule }}</dt>
            }
          }
        </dl>
      </ng-template>

      <span
        class="new-reservation-dialog__rules-badge"
        [cueTooltipCommonType]="'info'"
        [cueTooltip]="resourceSchedulingRulesTemplate"
      >
        <cue-icon [icon]="icons.cueInfo" />
        {{ translation.newReservationUi.location.reservationRules | transloco }}
      </span>
    }

    @if (resourceRow.canRemove) {
      <cue-button
        type="secondary"
        btnClass="small new-reservation-dialog__inline-button"
        (click)="onChangeLocation($event)"
      >
        {{ translation.newReservationUi.location.changeLocation | transloco }}
      </cue-button>

      <cue-button
        type="delete"
        [icon]="icons.cueDelete"
        btnClass="autowidth new-reservation-dialog__icon-cue-button"
        [title]="translation.newReservationUi.location.removeLocation | transloco"
        (click)="onRemoveLocation($event)"
      />
    }
  </div>
</div>
